import { locationIdFormat } from "@redotech/redo-inventory-id";
import { barcodeLabelSize } from "@redotech/redo-model/inventory/barcode-label";
import * as z from "zod";

export const generateSortingLicensePlate = {
  name: "generateSortingLicensePlate" as const,
  input: z.object({
    returnId: z.string().min(1),
    locationId: locationIdFormat.schema,
    printerId: z.number().optional(),
    printerOptions: z.record(z.string(), z.unknown()).optional(),
    labelSize: z.enum(barcodeLabelSize).optional(),
  }),
  output: z.object({ pdfBase64: z.string(), printed: z.boolean().optional() }),
};
